import styled, { css } from 'styled-components';

import {
  NonBenefitMedicine,
  NonBenefitPriceSummary,
} from '@/models/nonBenefit';
import { formatPriceComma } from '@/utils/format';

interface Props {
  nonBenefitPriceTotalSummary: NonBenefitPriceSummary;
  selectedMedicine: NonBenefitMedicine;
  selectedAddressTitle: string;
}
const NonBenefitTotalSummaryTable = ({
  nonBenefitPriceTotalSummary,
  selectedAddressTitle,
  selectedMedicine,
}: Props) => {
  return (
    <SummaryTableWrapper>
      <SummaryTable>
        <thead>
          <SummaryTableRow>
            <SummaryTableHead>가격비교</SummaryTableHead>
            {selectedMedicine.units.map((unit) => (
              <SummaryTableHead key={`unit-${unit.id}`}>
                {unit.unitDisplayName} 처방
              </SummaryTableHead>
            ))}
          </SummaryTableRow>
        </thead>
        <tbody>
          <SummaryTableRow>
            <SummaryTableData>{`${selectedAddressTitle} \n최저가`}</SummaryTableData>
            {nonBenefitPriceTotalSummary.regionSummaries.map(
              (regionSummary) => (
                <SummaryTableData
                  key={`region-min-${regionSummary.unitDisplayName}`}
                  cheapest
                >
                  {formatPriceComma(regionSummary.minPrice)}원
                </SummaryTableData>
              ),
            )}
          </SummaryTableRow>
          <SummaryTableRow>
            <SummaryTableData>{`${selectedAddressTitle} \n평균가`}</SummaryTableData>
            {nonBenefitPriceTotalSummary.regionSummaries.map(
              (regionSummary) => (
                <SummaryTableData
                  key={`region-avg-${regionSummary.unitDisplayName}`}
                >
                  {formatPriceComma(regionSummary.averagePrice)}원
                </SummaryTableData>
              ),
            )}
          </SummaryTableRow>
          <SummaryTableRow>
            <SummaryTableData>{`전국 \n평균가`}</SummaryTableData>
            {nonBenefitPriceTotalSummary.nationalSummaries.map(
              (nationalSummary) => (
                <SummaryTableData
                  key={`national-avg-${nationalSummary.unitDisplayName}`}
                >
                  {formatPriceComma(nationalSummary.averagePrice)}원
                </SummaryTableData>
              ),
            )}
          </SummaryTableRow>
        </tbody>
      </SummaryTable>
    </SummaryTableWrapper>
  );
};

export default NonBenefitTotalSummaryTable;
const SummaryTableWrapper = styled.div`
  padding: 10px 24px;
`;

const SummaryTable = styled.table`
  width: 100%;
`;

const SummaryTableRow = styled.tr`
  flex: 1;
  width: 100%;
`;

const SummaryTableHead = styled.th`
  flex: 1;
  height: 32px;
  ${({ theme }) => css`
    ${theme.typography.UI15R}
    border: 1px solid ${theme.color.gray100};
    background-color: ${theme.color.gray20};
    color: ${theme.color.gray500};
  `}
`;
const SummaryTableData = styled.td<{ cheapest?: boolean }>`
  flex: 1;
  ${({ theme, cheapest }) => css`
    ${theme.typography.UI15R}
    border: 1px solid ${theme.color.gray100};
    background-color: ${theme.color.white};
    color: ${cheapest ? theme.color.primary600 : theme.color.gray500};
    white-space: ${theme.client.isMobile ? 'pre-line' : 'normal'};
    height: ${theme.client.isMobile ? 48 : 32}px;
    text-align: center;
  `}
`;
